export const fuseOptions = {
  includeScore: true,
  shouldSort: true,
  includeMatches: false,
  threshold: 0.05,
  useExtendedSearch: false,
  keys: ["expression", "hiragana", "gems", "kanjis", "senses.meanings"],
};
